import { Button } from "@/components/ui/button";
import { ChevronsLeft, ChevronsRight } from "lucide-react";
import { JSX } from "react";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({
  currentPage,
  totalPages,
  onPageChange,
}: PaginationProps): JSX.Element {
  return (
    <div className="mt-4 flex items-center justify-center space-x-2">
      <Button
        variant={"outline"}
        className="bg-transparent"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 0}
      >
        <ChevronsLeft className="size-4" />
      </Button>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <Button
        variant={"outline"}
        className="bg-transparent"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronsRight className="size-4" />
      </Button>
    </div>
  );
}
